/**
 * Formats domain display for professional, enterprise-grade UI.
 * Always returns just the name, hiding symbols (emojis, abbreviations, or duplicates).
 * 
 * Examples:
 * - { symbol: "Competition", name: "Competition" } → "Competition"
 * - { symbol: "HITL", name: "Human in the Loop" } → "Human in the Loop"
 * - { symbol: "🚁", name: "Auto Construction" } → "Auto Construction"
 * - { name: "Adoption" } → "Adoption"
 */
export const formatDomainDisplay = (domain: { 
  symbol?: string | null; 
  name: string 
}): string => {
  // Enterprise-grade: clean, professional, name only
  return domain.name;
};
